// @flow
import domainsService from '@clubmed/domains-service';

// WARNING: iF this file is growing too much, think of replacing it with a library like Validator.js

function isPhoneNumber(stringToTest: string): boolean {
  return /^[\d\s()+-.]+$/.test(stringToTest.trim());
}

const emailRegex = new RegExp(
  /^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/,
);

const getPhoneRegex = (locale: string) =>
  new RegExp(
    domainsService.getDomain(locale)?.fields?.phoneNumber ||
      /^ *\+? *(?:[ \-()]*[0-9][ \-()]*){6,12}$/,
  );

export { isPhoneNumber, emailRegex, getPhoneRegex };
